import api from './api';

interface SubscriptionResponse {
  subscriptionId: string;
  expirationDateTime: string;
  resource: string;
}

class SubscriptionService {
  /**
   * Crea una subscription de Microsoft Graph para recibir
   * notificaciones de nuevos emails en tiempo real (webhook)
   */
  async createSubscription(companyId: string): Promise<SubscriptionResponse | null> {
    const response = await api.post<SubscriptionResponse>('/email/subscriptions/create', {
      companyId,
    });

    if (response.success && response.data) {
      return response.data;
    }

    if (response.error) {
      throw new Error(response.error.message || 'Error al crear subscription');
    }

    return null;
  }

  /**
   * Crea una subscription de Gmail (Pub/Sub) para recibir
   * notificaciones de nuevos emails en tiempo real
   */
  async createGmailSubscription(companyId: string): Promise<SubscriptionResponse | null> {
    const response = await api.post<SubscriptionResponse>('/email/subscriptions/gmail/create', {
      companyId,
    });

    if (response.success && response.data) {
      return response.data;
    }

    if (response.error) {
      throw new Error(response.error.message || 'Error al crear subscription de Gmail');
    }

    return null;
  }

  /**
   * Renueva una subscription de Microsoft Graph existente (+3 días)
   * Normalmente NO se necesita llamar desde front (lo hace una Cloud Function)
   */
  async renewSubscription(companyId: string, subscriptionId: string) {
    const response = await api.post('/email/subscriptions/renew', {
      companyId,
      subscriptionId,
    });

    if (response.success && response.data) {
      return response.data;
    }

    if (response.error) {
      throw new Error(response.error.message || 'Error al renovar subscription');
    }

    return null;
  }

  /**
   * Renueva una subscription de Gmail (Pub/Sub)
   */
  async renewGmailSubscription(companyId: string) {
    const response = await api.post('/email/subscriptions/gmail/renew', {
      companyId,
    });

    if (response.success && response.data) {
      return response.data;
    }

    if (response.error) {
      throw new Error(response.error.message || 'Error al renovar subscription de Gmail');
    }

    return null;
  }

  /**
   * Elimina una subscription (al desconectar la cuenta de email)
   */
  async deleteSubscription(companyId: string, subscriptionId: string) {
    const response = await api.delete('/email/subscriptions', {
      data: { companyId, subscriptionId },
    });

    if (response.success && response.data) {
      return response.data;
    }

    if (response.error) {
      throw new Error(response.error.message || 'Error al eliminar subscription');
    }

    return null;
  }
}

export default new SubscriptionService();
